import { Col, Row } from 'react-styled-flexboxgrid';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { rotate360Rule } from 'shared-assets/lib/animations';
import colors from 'shared-assets/lib/colors';

const Spinner = styled.span.attrs(() => ({
  className: 'spinner',
}))`
  && {
    animation: ${rotate360Rule};
    display: flex;
    height: ${props => props.size};
    width: ${props => props.size};
    border: ${props => props.thickness} solid
      rgba(${props => props.rgb.join(', ')}, 0.2);
    border-left: ${props => props.thickness} solid
      rgba(${props => props.rgb.join(', ')}, 0.45);
    border-radius: 100%;
  }
`;

Spinner.defaultProps = {
  thickness: '5px',
  size: '1rem',
  rgb: [0, 0, 0],
  children: undefined,
  style: undefined,
};

Spinner.propTypes = {
  thickness: PropTypes.string,
  size: PropTypes.string,
  rgb: PropTypes.arrayOf(PropTypes.number.isRequired),
  children: PropTypes.node,
  style: PropTypes.object,
};

export default Spinner;

export const SpinnerWithText = props => {
  // We disabled eslint for the next line because we couldn't resolve the eslint
  // error for `react/prop-types` even though we added the prop types
  // eslint-disable-next-line
  let { children, style, ...rest } = props;
  return (
    <Row first="xs" middle="xs" style={style}>
      <Col key="1">
        <Spinner {...rest} />
      </Col>
      <Col
        key="2"
        style={{
          paddingLeft: '0px',
          color: colors.light,
        }}
      >
        <span>{children}</span>
      </Col>
    </Row>
  );
};
